import { css } from '@isceco/widget-library2/external/lit'
import { RadioGroup as BaseRadioGroup } from '@isceco/widget-library2/basic-elements/RadioGroup/RadioGroup.js'

class CustomRadioGroupVertical extends BaseRadioGroup {
  static get styles() {
    return [
      super.styles,
      css`
        .radios {
          display: flex;
          flex-direction: column;
        }
        .radio {
          margin-right: 0;
        }
        .radio label {
          height: 32px;
        }
        .inline > .label-wrapper > label {
          font-weight: normal;
        }
      `
    ]
  }

  firstUpdated() {
    if (!this.value) {
      const attrValue = this.getAttribute('value')
      if (attrValue != null) {
        this.value = attrValue
        this.requestUpdate()
      }
    }
  }
}

customElements.define('isceco-custom-radio-group-vertical', CustomRadioGroupVertical)
